import React from 'react';
interface SectionHeadingProps {
  id: string;
  index: number;
  title: string;
  intro: string;
}
export function SectionHeading({
  id,
  index,
  title,
  intro
}: SectionHeadingProps) {
  return <div className="max-w-3xl" data-id="element-1187" data-mp="2yweo7eoofmsk">
      <p className="text-[14px] font-medium tabular-nums text-ink-muted" data-id="element-1188" data-mp="2yvdbl5s0is8q">Hoofdstuk {index}</p>
      <h2 id={`${id}-title`} className="mt-2 font-display text-[40px] font-light leading-tight text-ink lg:text-[48px]" data-id="element-1189" data-mp="33tok9d6kmwpd">
        {title}
      </h2>
      <p className="mt-4 text-[17px] leading-relaxed text-ink-soft" data-id="element-1190" data-mp="2twtpn5df5ggd">{intro}</p>
    </div>;
}
export function SpecSection({
  id,
  children
}: {
  id: string;
  children: React.ReactNode;
}) {
  return <section id={id} aria-labelledby={`${id}-title`} className="scroll-mt-20 border-t border-white/[0.06] py-20 lg:py-28" data-id="element-1191" data-mp="2kw3vs77py05a">
      {children}
    </section>;
}